module.exports = __webpack_public_path__ + "static/media/cybercrime-large@2x.c8107c20.png";